(function () {
    angular.module("metaNavComponent", [])
        .component("metaNav",
            {
                templateUrl: "/Scripts/app/meta-nav/meta-nav.template.html",
                bindings: {
                    ticketButtonText: "@",
                    ticketButtonAltText: "@",
                    ticketButtonUrl: "@",
                    ticketWidgetTitle: "@",
                    ticketNowPlayingText: "@",
                    ticketMoviePlaceholder: "@",
                    ticketMovieInputPrompt: "@",
                    ticketFavouriteTheatresText: "@",
                    ticketSearchedTheatresText: "@",
                    ticketNearbyTheatresText: "@",
                    ticketOtherTheatresText: "@",
                    ticketTheatrePlaceholder: "@",
                    ticketTheatreInputPrompt: "@",
                    ticketAvailableDatesText: "@",
                    ticketDatePlaceholder: "@",
                    ticketDateInputPrompt: "@",
                    todayText: "@",
                    tomorrowText: "@",
                    ticketMovieNotFoundError: "@",
                    ticketTheatreNotFoundError: "@",
                    findShowtimeButtonText: "@",
                    locationButtonText: "@",
                    locationButtonAltText: "@",
                    locationButtonUrl: "@",
                    searchButtonText: "@",
                    searchButtonAltText: "@",
                    searchButtonUrl: "@",
                    accountButtonText: "@",
                    accountButtonAltText: "@",
                    loginText: "@",
                    logoutText: "@",
                    signupPrompt: "@",
                    signupText: "@",
                    manageAccountText: "@",
                    scenePointsLabel: "@",
                    searchPlaceholder: "@",
                    searchBtnText: "@",
                    searchUrl: "@",
                    showtimesUrl: "@",
                    filmUrl: "@",
                    storeUrl: "@",
                    lang: "@",
                    getRewardedText: "@",
                    sceneLogoUrl: "@",
                    sceneTrackingUrl: "@",
                    closeDrawerButtonAltText: "@",
                    ticketingUrl: "@",
                    deepLinkingPrompt: "@"
                },
                controller: ["$scope", "$timeout", "$element", metaNavController]
            });

    function metaNavController($scope, $timeout, $element) {

        var self = this;

        //State Variables
        self.currentTab = 0;
        self.mobileNavOpened = false;
        self.sidenavOpened = false;
        self.sidenavMenuLoaded = false;
        self.userLoggedIn = false;
        self.userProfile = {};
        self.lastScrollTop = 0;
        self.desktopBreakpoint = 1024;
        self.isDeepLinking = false;
        self.deepLinkingMovie = "";

        //search widget variables
        self.hasMobileToggle = true;
        self.isSearchBoxOpen = false;
        self.submitDisabled = true;
        
        //Component Functions
        self.$onInit = initFunction;
        self.openTicketMenu = openTicketMenu;
        self.openLocationMenu = openLocationMenu;
        self.openSearchMenu = openSearchMenu;
        self.openAccountMenu = openAccountMenu;
        self.closeMenu = closeSideNav;
        self.toggleMobileNav = toggleMobileNav;
        self.openLoginScreen = openLoginScreen;
        self.openSignUpScreen = openSignUpScreen;
        self.openAccountManagement = openAccountManagement;
        self.logout = logoutUser;

        //event handlers
        $scope.$on('ticketWidgetInitialized', function () {
            self.sidenavMenuLoaded = true;
            attachNextTabHandler('#meta-nav-menu--tickets', '#meta-nav-drawer--ticket-widget selectize-input input');
            $timeout(function () {
                $('#select-movie').trigger('ticketWidgetLoaded');
            });
        });

        function initFunction() {
            attachMobileCloseListener();
            $timeout(function () {
                $element.trigger('metaNavLoaded');
            });

            //this deep linking implementation requires the film title to be present on the page
            self.deepLinkingMovie = $('#filmTitle').text().trim();
            if (getParameterByName('deepLinkToSession') && self.deepLinkingMovie) {
                attachDeepLinkingEvent();
            }
        }

        function openTicketMenu() {
            if (self.ticketButtonUrl) {
                window.location.href = self.ticketButtonUrl;
            } else {
                openSideNav();
                self.currentTab = 1;
                $scope.$broadcast('initTicketWidget');
                attachTabToDrawerCloseOnDesktop('#meta-nav-menu--tickets');
                scopeApply();
               
            }
        }

        function openLocationMenu() {
            if (self.locationButtonUrl) {
                window.location.href = self.locationButtonUrl;
            } else {
                openSideNav();
                self.currentTab = 2;
                self.sidenavMenuLoaded = true;
                scopeApply();
            }
        }

        function openSearchMenu() {
            if (self.searchButtonUrl) {
                window.location.href = self.searchButtonUrl;
            } else {
                openSideNav();
                self.currentTab = 3;
                self.sidenavMenuLoaded = true;
                attachNextTabHandler('#meta-nav-menu--search', '#meta-nav-drawer--search-widget .cineplex-search input');
                scopeApply();
            }
        }

        function openAccountMenu() {
            openSideNav();
            initAccountWidget();
            self.currentTab = 4;
            scopeApply();
        }

        function openSideNav() {
            self.sidenavOpened = true;
            self.mobileNavOpened = true;
            self.sidenavMenuLoaded = false;
            self.lastScrollTop = $(window).scrollTop();
            scrollToNavForMobile();
            disableBodyScrolling();
            enableSideNavResize();
            $scope.$broadcast('sideNavOpened');
            scopeApply();
        }

        function closeSideNav() {
            if ($('.mobile-dropdown-toggle').hasClass('nav-opened') || !($('#site-navbar-wrap button.mobile-toggle').hasClass('collapsed'))) {
                enableBodyScrolling();
                $(window).scrollTop(self.lastScrollTop);
            }
            if ($(window).innerWidth >= self.desktopBreakpoint) {
                enableBodyScrolling();
            }
            self.sidenavOpened = false;
            self.currentTab = 0;
            
            disableSideNavResize();
            $scope.$broadcast('sideNavClosed');
            scopeApply();
        }

        function toggleMobileNav() {
            if ($("#site-navbar-wrap").hasClass("fixed-scroll")) {
                self.mobileNavOpened = !self.mobileNavOpened;
            }
            enableBodyScrolling();
            scopeApply();
        }

        function attachNextTabHandler(listener, target) {
            if ($(listener).is(document.activeElement)) {
                $element.off('keydown', listener);
                $element.off('blur', listener);

                $element.on('keydown', listener, function (e) {
                    if (e.keyCode == 9) {
                        if (!e.shiftKey) {
                            var targetElem = $element.find(target).first();
                            if (targetElem.length) {
                                targetElem.focus();
                                e.preventDefault();
                            }
                        }
                    }
                });

                $element.on('blur', listener, function () {
                    $element.off('keydown', listener);
                    $element.off('blur', listener);
                });
            }
        }

        function attachTabToDrawerCloseOnDesktop(listener) {
            if (window.innerWidth >= self.desktopBreakpoint) {
                attachNextTabHandler(listener, '#meta-nav-drawer--close');
            }
        }

        function attachMobileCloseListener() {
            $("#site-navbar-wrap button.mobile-toggle").click(function () {
                if (self.mobileNavOpened) {
                    $('#meta-nav-container').addClass('no-animate');
                    self.mobileNavOpened = false;
                    scopeApply();
                }
                closeSideNav();
            });
        }

        $('#mobile-nav').on('shown.bs.collapse', function () {
            $('#meta-nav-container').removeClass('no-animate');
        });

        function scrollToNavForMobile() {
            
            var navOffsetTop = 0;
            if ($('#top-ad-container').hasClass('fixed-scroll')) {
                    navOffsetTop += $('.banner-container').height() || 0;
                    navOffsetTop += $('.smartbanner').height() || 0;
            }
            var navPos = $('#site-navbar-wrap').position().top;
            navOffsetTop += navPos;
            if (navPos !== 0) {
                //Only scroll for mobile/tablet and if the nav isn't already fixed at the top
                if (window.innerWidth < self.desktopBreakpoint && $(".body-wrapper").scrollTop() < navOffsetTop) {
                    $('.body-wrapper').animate({
                        scrollTop: navOffsetTop
                    }, 200, resizeSideNav);
                    self.mobileNavOpened = true;
                }
            }
            else {
                $('#site-navbar-wrap')
                    .addClass('fixed-scroll')
                    .nextAll(':not(script):not(style):not(meta):not(noscript)').first().addClass('fixed-scroll-offset');
            }
        }

        function disableBodyScrolling() {
            $('.body-wrapper').addClass('sidenav-opened');
            $('body,html').addClass('sidenav-opened-desktop');
        }

        function enableBodyScrolling() {
            $('.body-wrapper').removeClass('sidenav-opened');
            $('body,html').removeClass('sidenav-opened-desktop');
        }

        function resizeSideNav() {
            var metaNav = document.getElementById('meta-nav-drawer');
            var sideNavHeight = window.innerHeight - metaNav.getBoundingClientRect().top;
            $(metaNav).css('max-height', sideNavHeight);
        }

        function enableSideNavResize() {
            resizeSideNav();

            //Someone might close an element on the page that changes the offset of the nav
            $(document).on('click', resizeSideNav); 
            $(window).on('resize', resizeSideNav);
            $(window).on('scroll', resizeSideNav);
            $element.on('resizeSideNav', resizeSideNav);
        }

        function disableSideNavResize() {
            $(document).off('click', resizeSideNav);
            $(window).off('resize', resizeSideNav);
            $(window).off('scroll', resizeSideNav);
            $element.off('resizeSideNav', resizeSideNav);
        }

        //Account Functions
        function initAccountWidget() {
            self.userLoggedIn = Cineplex.Connect.IsUserLoggedIn();
            if (self.userLoggedIn) {
                attachTabToDrawerCloseOnDesktop('#meta-nav-menu--account');
                getUserProfileInfo();
            } else {
                self.sidenavMenuLoaded = true;
                attachNextTabHandler('#meta-nav-menu--account', '#meta-nav-drawer--account-widget button.login');
            }
            scopeApply();
        }

        function openLoginScreen() {
            closeSideNav();
            Cineplex.Connect.OpenConnectPage(Cineplex.Connect.Page.Login);
        }

        function openSignUpScreen() {
            closeSideNav();
            Cineplex.Connect.OpenConnectPage(Cineplex.Connect.Page.SignUp);
        }

        function openAccountManagement() {
            Cineplex.Connect.OpenManageAccount(Cineplex.Connect.Page.Overview)
        }

        function logoutUser() {
            Cineplex.Connect.LogOut();
        }

        function getUserProfileInfo() {
            var profileInfo = Cineplex.Connect.GetUserStatus();
            Cineplex.Connect.GetConnectUser(function (user) {
                self.userProfile = {
                    initials: profileInfo.Initials,
                    name: profileInfo.FirstName + ' ' + profileInfo.LastName,
                    email: user.Email,
                    scenePoints: profileInfo.PrimarySceneCardPointsBalance,
                    get hasSceneCard() {
                        return this.scenePoints && this.scenePoints !== '';
                    },
                    profilePictureUrl: profileInfo.ProfilePicture,
                    get hasProfilePicture() {
                        return this.profilePictureUrl && this.profilePictureUrl !== '';
                    }
                };
                self.sidenavMenuLoaded = true;
                attachNextTabHandler('#meta-nav-menu--account', '#meta-nav-drawer--account-widget .logged-in-content a');
                scopeApply();
            });
        }

        function attachDeepLinkingEvent() {
            var locationId = getParameterByName('LocationId');
            var sessionId = getParameterByName('VistaSessionId');
            var areaCode = getParameterByName('VISTAHOAreaCategoryCode');
            var redirectUrl = self.ticketingUrl
                .replace("{0}", locationId)
                .replace("{1}", sessionId)
                .replace("{2}", areaCode);

            if (sessionId && areaCode && locationId) {
                $(document).on("Cineplex.Connect.Initialized", function () {
                    if (Cineplex.Connect.IsUserLoggedIn()) {
                        window.location.href = redirectUrl;
                    } else {
                        self.isDeepLinking = true;
                        redirectToUrlOnLogin(redirectUrl);
                        openAccountMenu();
                    }
                });
            }
        }

        function redirectToUrlOnLogin(url) {
            var oldConnectCloseFunction = Cineplex.Connect.Settings.Close;
            Cineplex.Connect.Settings.Close = function () {
                if (Cineplex.Connect.IsUserLoggedIn()) {
                    //update the history as well so the user can properly press 'back'
                    history.replaceState(null, document.title, location.protocol + '//' + location.host + location.pathname);
                    window.location.href = url;
                }
                oldConnectCloseFunction();
            }
        }
       
        //Shared Functions

        function scopeApply() {
            $timeout(function () { $scope.$apply(); });
        }

        function getParameterByName(name, url) {
            if (!url)
                url = window.location.search;

            if (URLSearchParams) {
                var urlParams = new URLSearchParams(url);
                return urlParams.get(name);
            } else {
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }
        }
    }
})();